"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var persisted_queue_1 = require("./persisted-queue");
var client_1 = require("./client");
var analytics_cookie_1 = require("./analytics-cookie");
var ERROR = 'error';
var INFO = 'info';
var ENABLED = true;
var ravenClient = null;
var userContext = {
    cookie_id: analytics_cookie_1.default.trackingId(),
};
function buildEvent(name, data, jsError, level) {
    if (data === void 0) { data = {}; }
    var eventName = name;
    var props;
    if (name.$type) {
        eventName = name.$type.name;
        props = name;
    }
    else {
        props = data;
    }
    var eventData = Object.assign({}, props);
    eventData.user_context = userContext;
    return {
        name: eventName,
        data: eventData,
        error: jsError,
        level: level,
    };
}
// Configure has a side effect of draining the queue
// we have this as our drain queue entry point because
// before this point we will not have the information
// needed to send our payload.
function configure(opts) {
    if (Object.hasOwnProperty.call(opts, 'enabled')) {
        ENABLED = opts.enabled;
    }
    if (opts.ravenClient) {
        ravenClient = opts.ravenClient;
    }
    client_1.default.configure({
        host: opts.host,
        timeout: opts.timeout,
        apiKey: opts.apiKey,
        buffer: opts.buffer,
        local: opts.local,
    });
    analytics_cookie_1.default.configure(opts);
    persisted_queue_1.default.drain();
}
exports.configure = configure;
function identify(user) {
    if (ravenClient) {
        ravenClient.setUserContext(user);
    }
    Object.assign(userContext, user);
}
exports.identify = identify;
function trackOnClickThrough(name, data) {
    if (data === void 0) { data = {}; }
    var queue = persisted_queue_1.default.get();
    queue.push(buildEvent(name, data));
    persisted_queue_1.default.save(queue);
}
exports.trackOnClickThrough = trackOnClickThrough;
function post(event, endpoint) {
    if (ENABLED !== true) {
        return;
    }
    client_1.default.post([event], endpoint);
}
exports.post = post;
function track(name, data) {
    if (data === void 0) { data = {}; }
    var event = buildEvent(name, data);
    post(event, 'events');
}
exports.track = track;
function error(name, data, jsError) {
    if (data === void 0) { data = {}; }
    var event = buildEvent(name, data, jsError, ERROR);
    if (!!ravenClient) {
        ravenClient.captureException(jsError);
    }
    post(event, 'events');
}
exports.error = error;
function info(name, data) {
    if (data === void 0) { data = {}; }
    var event = buildEvent(name, data, null, INFO);
    post(event, 'events');
}
exports.info = info;
function gauge(gauge) {
    post(gauge, 'gauges');
}
exports.gauge = gauge;
exports.default = {
    configure: configure,
    identify: identify,
    gauge: gauge,
    track: track,
    error: error,
    info: info,
    trackOnClickThrough: trackOnClickThrough,
};



//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.ecs-deploy.production/build/src/node_modules/@reverbdotcom/elog/dist/index.js
// module id = qxwb
// module chunks = 20